var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenshotsIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_7789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3594 19.5741C27.3594 20.4398 26.6576 21.1416 25.7919 21.1416H2.5675C1.70179 21.1416 1 20.4398 1 19.5741V2.5675C1 1.70179 1.70179 1 2.5675 1H25.7919C26.6576 1 27.3594 1.7018 27.3594 2.5675V19.5741Z",
    stroke: "#605BFF",
    strokeWidth: 1.38033,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 23.7783H20.7422",
    stroke: "#605BFF",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 17.1099C11.2404 16.1332 9.25781 13.3913 9.25781 10.3029V7.2975L14.1797 5.66211L19.1016 7.2975V10.3029C19.1016 13.3913 17.119 16.1332 14.1797 17.1099Z",
    fill: "#605BFF",
    stroke: "#605BFF",
    strokeWidth: 1.38033,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 8.32568V10.1567",
    stroke: "white",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 13.8188H15",
    stroke: "white",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_7789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotsIcon);
export default __webpack_public_path__ + "static/media/ScreenshotsIcon.8f96d50422ef3c2f4fa3a80e5f510d95.svg";
export { ForwardRef as ReactComponent };